import { Link, Head } from "@inertiajs/react"
import { Button } from "@/components/ui/button"

export default function Home() {
  return (
    <>
      <Head title="LeadFlow">
        <meta name="description" content="Blue Beetle lead management, follow-up, and performance tracking." />
        <meta property="og:title" content="LeadFlow" />
        <meta property="og:description" content="Blue Beetle lead management, follow-up, and performance tracking." />
      </Head>
      <main className="mx-auto flex min-h-screen max-w-2xl flex-col items-center justify-center px-4 py-16 text-center">
        <h1>LeadFlow</h1>
        <p className="mt-2 max-w-md text-ink-muted">Blue Beetle lead management, follow-up, and performance tracking.</p>
        <div className="mt-6 flex items-center gap-3">
          <Button asChild>
            <Link href="/login">Sign in</Link>
          </Button>
        </div>
      </main>
    </>
  )
}
